

export default class ValidationManager {

    //#region Contests

    static contestScopeIsValid(scope, locationId, groupId) {
        switch (scope) {
            case "ca": return true;
            case "location": return !ValidationManager.isNullOrUndefined(locationId);
            case "group": return !ValidationManager.isNullOrUndefined(groupId);
        }
        return false;
    }

    static contestRaffleMetricIsValid(metric, usingMasterKpi) {
        if (ValidationManager.isMultipleNullOrUndefined([metric, metric.isLowerBetter, metric.isRepeatable,
            metric.ticketCount, metric.value, (usingMasterKpi ? metric.masterKpiId : metric.reportKpiId)])) {
            return false;
        }

        if (!Number.isInteger(parseInt(metric.ticketCount)) || parseInt(metric.ticketCount) <= 0) {
            return false;
        }

        if (ValidationManager.isStringNullOrEmpty(metric.value) || !ValidationManager.isStringNumeric(metric.value)) {
            return false;
        }

        if (!ValidationManager.isBoolean(metric.isLowerBetter)) {
            return false;
        }

        if (!ValidationManager.isBoolean(metric.isRepeatable)) {
            return false;
        }

        return true;
    }

    static contestRankedMetricIsValid(metric, usingMasterKpi) {
        if (ValidationManager.isMultipleNullOrUndefined([metric, metric.isLowerBetter,
            (usingMasterKpi ? metric.masterKpiId : metric.reportKpiId)])) {
            return false;
        }

        if (!ValidationManager.isBoolean(metric.isLowerBetter)) {
            return false;
        }

        return true;
    }

    static contestQualifierIsValid(qualifier, usingMasterKpi) {
        if (ValidationManager.isMultipleNullOrUndefined([qualifier, qualifier.isLowerBetter,
            qualifier.value, (usingMasterKpi ? qualifier.masterKpiId : qualifier.reportKpiId)])) {
            return false;
        }

        if (ValidationManager.isStringNullOrEmpty(qualifier.value) || !ValidationManager.isStringNumeric(qualifier.value)) {
            return false;
        }

        if (!ValidationManager.isBoolean(qualifier.isLowerBetter)) {
            return false;
        }

        return true;
    }

    //#endregion

    //#region General

    static blank() {
        return true;
    }

    static isNullOrUndefined(obj) {
        return (obj === null || obj === undefined)
    }

    static isStringNullOrEmpty(str) {
        return str === null || str.trim() === "";
    }

    static isMultipleNullOrUndefined(arr) {
        if (ValidationManager.isNullOrUndefined(arr)) {
            return true;
        }

        let result = false;
        try {
            arr.forEach(obj => {
                if (ValidationManager.isNullOrUndefined(obj)) {
                    result = true;
                }
            })
        } catch (ex) {
            return true;
        }

        return result;
    }

    static isStringNumeric(str) {
        return ValidationManager.isStringInteger(str) || ValidationManager.isStringFloat(str);
    }

    static isStringInteger(str) {
        let regInt = /^\d+$/;

        return regInt.test(str);
    }

    static isStringFloat(str) {
        let regFloat = /^\d*\.\d+$/;

        return regFloat.test(str);
    }

    static isBoolean(bool) {
        return bool === true || bool === false;
    }

    static isDateTimeValid(dt) {
        if (ValidationManager.isNullOrUndefined(dt)) {
            return false;
        }
        if (!Number.isInteger(dt)) {
            return false;
        }

        return (dt + "").length === 8;
    }

    //#endregion
}
